"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_Z_INDEX = exports.MDL = exports.CSS = void 0;
var input_1 = require("../input/input");
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-Modal',
    modal: 'c-Modal-Container',
    title: 'c-Modal-Title',
    actions: 'c-Modal-Actions',
    content: 'c-Modal-Content',
    action: {
        ok: 'c-Modal-Actions__Ok',
        cancel: 'c-Modal-Actions__Cancel'
    },
    isOpen: 'c-Modal--open'
};
exports.MDL = {
    button: 'mdl-button'
};
exports.MODAL_Z_INDEX = 100;
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = (_b = {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: '100%',
            height: '100%',
            'background-color': theme_1.DefaultTheme.font.color.supporting,
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center',
            'z-index': exports.MODAL_Z_INDEX - 1
        },
        _b["& .".concat(input_1.Input.CSS.container)] = {
            width: '100%'
        },
        _b),
    _a[exports.CSS.modal] = {
        'z-index': exports.MODAL_Z_INDEX,
        'min-width': '280px',
        'max-height': '90%',
        background: theme_1.DefaultTheme.background.offWhite,
        display: 'flex',
        'flex-direction': 'column',
        margin: 0,
        width: 'auto',
        height: 'auto',
        opacity: 0,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        transition: 'opacity 0.25s ease'
    },
    _a[exports.CSS.isOpen + ' .' + exports.CSS.modal] = {
        opacity: 1
    },
    _a[exports.CSS.title] = {
        color: (0, theme_1.rgba)(theme_palette_1.WHITE),
        padding: "".concat(theme_1.DefaultTheme.space(2), " ").concat(theme_1.DefaultTheme.space(6)),
        'font-size': theme_1.DefaultTheme.font.size * 1.1 + 'px',
        'background-color': theme_1.DefaultTheme.background.darkGrey
    },
    _a[exports.CSS.content] = {
        color: theme_1.DefaultTheme.font.color.supporting,
        padding: theme_1.DefaultTheme.space(6),
        'padding-bottom': theme_1.DefaultTheme.space(1),
        overflow: 'auto'
    },
    _a[exports.CSS.actions] = (_c = {
            'text-align': 'right',
            padding: theme_1.DefaultTheme.space(2)
        },
        _c["& .".concat(exports.CSS.action.ok)] = {
            color: theme_1.DefaultTheme.color.accent
        },
        _c),
    _a));
//# sourceMappingURL=modal.style.js.map